import * as constants from './constants';

const INITIAL_STATE = {
  defaultProvince: null,
  defaultCity: null,
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_DEFAULT_PROVINCE:
      return { ...state, defaultProvince: action.payload };
    case constants.SET_DEFAULT_CITY:
      return { ...state, defaultCity: action.payload };
    default:
      return state;
  }
};

export default exportedObject;
